import React from "react";
import BaseSubRichText from "@v4/gatsby-theme-talend/src/components/modules/multiItem/SubRichText";
import formatContentfulRichText from "@v4/talend/src/utils/formatContentfulRichText";

const SubRichText = (props) => <BaseSubRichText formatContentfulRichText={formatContentfulRichText} {...props} />;

export default SubRichText;
